module.exports = {
  Active: true,
  Deactivated: false,
};
